import { render, staticRenderFns } from "./form-otp.vue?vue&type=template&id=32b225cb&scoped=true&"
import script from "./form-otp.vue?vue&type=script&lang=js&"
export * from "./form-otp.vue?vue&type=script&lang=js&"
import style0 from "./form-otp.vue?vue&type=style&index=0&id=32b225cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b225cb",
  null
  
)

export default component.exports